import { QueryClient } from "@tanstack/react-query";

const defaultQueryConfig = { staleTime: 0, refetchOnWindowFocus: false };

export const queryClient = new QueryClient({
  defaultOptions: { queries: defaultQueryConfig },
});

// Invalidate the cache automatically for the checkAuthenticated call
queryClient.invalidateQueries({
  queryKey: ["/api/auth/v1/status"],
});
queryClient.invalidateQueries({
  queryKey: ["/api/auth/v1/user"],
});
